import { useContext } from "react";

import {
  DSGoogleMapsContext,
  DSGoogleMapsContextData,
} from "../contexts/DSGoogleMaps";

export function useDSGoogleMaps(): DSGoogleMapsContextData {
  const context = useContext(DSGoogleMapsContext);

  if (!context) {
    throw new Error(
      "useDSGoogleMaps must be used within an DSGoogleMapsProvider"
    );
  }

  return context;
}
